export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum DomainType {
  RAW = 'raw',
  API = 'api',
  SSE = 'sse',
  CDN = 'cdn',
  IMAGES = 'images',
  STORAGE = 'storage',
}
